import * as React from 'react';
import { Table, Checkbox, CheckboxProps } from 'semantic-ui-react';

import { SprayEventId } from 'services/sprayEvents/types';
import RenderSubmissionSprayEventsTableRowDateCell from './components/RenderSubmissionSprayEventsTableRowDateCell';
import RenderSubmissionSprayEventsTableRowApplicatorCell from './components/RenderSubmissionSprayEventsTableRowApplicatorCell';
import RenderSubmissionSprayEventsTableRowEntitiesCell from './components/RenderSubmissionSprayEventsTableRowEntitiesCell';
import RenderSubmissionSprayEventsTableRowEntityNameCell from './components/RenderSubmissionSprayEventsTableRowEntityNameCell';
import RenderSubmissionSprayEventsTableRowVarietyCell from './components/RenderSubmissionSprayEventsTableRowVarietyCell';
import RenderSubmissionSprayEventsTableRowFinalSpray from './components/RenderSubmissionSprayEventsTableRowFinalSpray';
import RenderSubmissionSprayEventsTableRowParentEntities from './components/RenderSubmissionSprayEventsTableRowParentEntities';
import RenderSubmissionSprayEventsTableRowApplicationTypeCell from './components/RenderSubmissionSprayEventsTableRowApplicationTypeCell';

interface Props {
    value?: SprayEventId[];
    sprayEventId: SprayEventId;
    onToggleTableRowCheckbox: (
        event: React.FormEvent<HTMLInputElement>,
        data: CheckboxProps
    ) => void;
}
export default class RenderSubmissionSprayEventsTableRow extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const {
            value = [],
            sprayEventId,
            onToggleTableRowCheckbox
        } = this.props;

        return (
            <Table.Row textAlign="center">
                <Table.Cell collapsing className="events-table-cell-padding">
                    <Checkbox
                        id={sprayEventId}
                        checked={value.includes(sprayEventId)}
                        onChange={onToggleTableRowCheckbox}
                    />
                </Table.Cell>
                <RenderSubmissionSprayEventsTableRowDateCell
                    sprayEventId={sprayEventId}
                />
                <RenderSubmissionSprayEventsTableRowApplicationTypeCell
                    sprayEventId={sprayEventId}
                />

                <RenderSubmissionSprayEventsTableRowEntityNameCell
                    sprayEventId={sprayEventId}
                />
                <RenderSubmissionSprayEventsTableRowVarietyCell
                    sprayEventId={sprayEventId}
                />
                <RenderSubmissionSprayEventsTableRowApplicatorCell
                    sprayEventId={sprayEventId}
                />
                <RenderSubmissionSprayEventsTableRowFinalSpray
                    sprayEventId={sprayEventId}
                />
                <RenderSubmissionSprayEventsTableRowParentEntities
                    sprayEventId={sprayEventId}
                />
                <RenderSubmissionSprayEventsTableRowEntitiesCell
                    sprayEventId={sprayEventId}
                />
            </Table.Row>
        );
    }
}
